import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import './styles.css';
import { initTheme } from './lib/theme';
import { absorbSessionFromUrl } from './lib/auth';

// Silent sign-in for the embedded Forge Jira page: if a session token was
// injected via the URL fragment (#session=...), store it and strip it before
// anything renders, so the app boots straight past the login screen.
absorbSessionFromUrl();

// Apply the persisted theme (and start tracking the OS setting) before the
// first render so there's no flash of the wrong theme.
initTheme();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);
